(ns io.daskul.tutorial.webapp.domain.auth.change-password-events
  "Events for changing the authenticated user's password."
  (:require
   [ajax.core]
   [re-frame.core :as rf]
   [io.daskul.tutorial.webapp.shared.api.client :as api]))

(rf/reg-event-fx
 ::change-password
 (fn [{:keys [db]} [_ {:keys [current-password new-password]}]]
   {:db (-> db
            (assoc-in [:change-password :loading?] true)
            (assoc-in [:change-password :error] nil)
            (assoc-in [:change-password :success?] false))
    :http-xhrio {:method :post
                 :uri (str api/api-url "/auth/change-password")
                 :params {:current-password current-password
                          :new-password new-password}
                 :headers (api/auth-header)
                 :format (ajax.core/json-request-format)
                 :response-format (ajax.core/json-response-format {:keywords? true})
                 :on-success [::change-password-success]
                 :on-failure [::change-password-failure]}}))

(rf/reg-event-db
 ::change-password-success
 (fn [db _]
   (-> db
       (assoc-in [:change-password :loading?] false)
       (assoc-in [:change-password :success?] true)
       (assoc-in [:change-password :error] nil))))

(rf/reg-event-db
 ::change-password-failure
 (fn [db [_ {:keys [response]}]]
   (-> db
       (assoc-in [:change-password :loading?] false)
       (assoc-in [:change-password :success?] false)
       (assoc-in [:change-password :error]
                 (or (:message response) "Failed to change password")))))

(rf/reg-event-db
 ::reset
 (fn [db _]
   (dissoc db :change-password)))
